export default __webpack_public_path__ + "static/media/17.1f0fdebf.svg";